import React, { Fragment, useCallback, useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import {
  fetchFavoriteJobsRequest,
  deleteFavoriteJobRequest,
  resetFavoriteMessage,
} from "../../../redux/jobseeker/favorite_job/actions";
import { showToast } from "../../Common/Toast";
import { capitalize, generateSlug } from "../../Common/CommonFunction";
import { formatDate } from "../../Common/CommonFunction";
import Spinner from "../../Common/Spinner";
import { showSweetAlert } from "../../Common/SweetAlert";
import { Edit2, Trash2, Eye, Phone, Mail, Copy } from "react-feather";
import {
  Card,
  CardBody,
  CardHeader,
  Row,
  Col,
  Button,
  Input,
  Form,
} from "reactstrap";
import { formatExperienceOutput } from "../../Common/CommonFunction";
import NoDataFound from "../../Common/NoDataFound";
import { Link } from "react-router-dom";
import { customStyles } from "../../../Constant";
import { FaCalendarAlt } from "react-icons/fa";
import { addDays, startOfYear, endOfToday } from "date-fns";
import {
  DefinedRange,
  DateRangePicker,
  defaultStaticRanges,
} from "react-date-range";
import { unslugAndCapitalize } from "../../Common/CommonFunction";
const CustomHeader = ({ cell }) => (
  <th style={{ fontWeight: "bold" }}>{cell.label}</th>
);
const SavedJobs = () => {
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [searchQuery, setSearchQuery] = useState(""); // State for search query
  const [toggleDelet, setToggleDelet] = useState(false);
  const [datePickerOpen, setDatePickerOpen] = useState(false);
  const [formData, setFormData] = useState({
    dateRange: {
      key: "selection",
      startDate: startOfYear(new Date()), // Start of current year
      endDate: endOfToday(), // Today
      type: "ALL",
    },
  });



  // State for sorting
  const [sortColumn, setSortColumn] = useState("");
  const [sortDirection, setSortDirection] = useState("");
  const locale = {
    localize: {
      month: (monthIndex) => {
        const months = [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December",
        ];
        return months[monthIndex];
      },
      day: (dayIndex) => {
        const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
        return days[dayIndex];
      },
    },
    formatLong: {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    },
  };

  const customStaticRanges = [
    {
      label: "All",
      range: () => ({
        startDate: startOfYear(new Date()), // Start of current year
        endDate: endOfToday(), // Today
        type: "ALL",
      }),
      isSelected(range) {
        const definedRange = this.range();
        return (
          range.type === definedRange.type &&
          range.startDate.getTime() === definedRange.startDate.getTime() &&
          range.endDate.getTime() === definedRange.endDate.getTime()
        );
      },
    },

    ...defaultStaticRanges.map((range) => ({
      ...range,
      range: () => ({
        ...range.range(),
        type: range.label.toUpperCase().replace(/ /g, "_"), // Generate a type from the label
      }),
      isSelected(range) {
        const definedRange = this.range();
        return (
          range.type === definedRange.type &&
          range.startDate.getTime() === definedRange.startDate.getTime() &&
          range.endDate.getTime() === definedRange.endDate.getTime()
        );
      },
    })),
  ];

  const handleDateRangeChange = (ranges) => {
    const { selection } = ranges;
    let selectedType = "CUSTOM"; // Default to CUSTOM

    // Check if the selected range matches any predefined ranges
    for (let range of customStaticRanges) {
      const definedRange = range.range();
      if (
        selection.startDate.getTime() === definedRange.startDate.getTime() &&
        selection.endDate.getTime() === definedRange.endDate.getTime() &&
        selection.type === definedRange.type
      ) {
        selectedType = definedRange.type;
        break;
      }
    }

    setFormData({
      ...formData,
      dateRange: {
        ...selection,
        type: selectedType, // Set the type based on the selected range
      },
    });
    setDatePickerOpen(false); // Close the date picker after selecting a valid date range
  };

  useEffect(() => {
    console.log("Current FormData:", formData);
  }, [formData]);

  useEffect(() => {
    fetchJobs();
  }, [currentPage, perPage, formData, sortColumn, sortDirection]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  // Handle search input change
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  // Handle form submission
  const handleSubmit = (event) => {
    event.preventDefault();
    const data = {
      type: formData.dateRange.type,

      startDate: formData.dateRange.startDate
        ? formData.dateRange.startDate.toISOString()
        : null, // Convert Date objects to strings
      endDate: formData.dateRange.endDate
        ? formData.dateRange.endDate.toISOString()
        : null,
      keyword: searchQuery,
    };
    dispatch(fetchFavoriteJobsRequest(1, perPage, data, sortColumn, sortDirection));
  };

  const handlePerRowsChange = (newPerPage, page) => {
    setPerPage(newPerPage);
    setCurrentPage(page);
  };

  // const tableColumns = [
  //   {
  //     name: "#",
  //     short_column: "job_id",
  //     cell: (row, index) => (currentPage - 1) * perPage + index + 1,
  //     width: "70px",
  //     sortable: true,
  //     center: false,
  //   },
  //   {
  //     name: "Job Title",
  //     short_column: "job_name",
  //     cell: (row) =>
  //       row.job_name ? (
  //         <Link
  //           to={`${process.env.PUBLIC_URL}/jobseeker/job_details/${generateSlug(
  //             row.job_name,
  //             row.job_location,
  //             formatExperienceOutput(
  //               row.work_experience_min,
  //               row.work_experience_max
  //             ).replace("-", "-to-"),
  //             row.job_id
  //           )}`}
  //           title={"View Job"}
  //         >
  //           {capitalize(row.job_name)}
  //         </Link>
  //       ) : (
  //         "-"
  //       ),
  //     sortable: true,
  //     center: false,
  //   },
  //   {
  //     short_column: "company_name",

  //     name: "Company Name",
  //     cell: (row) => (row.company_name ? capitalize(row.company_name) : "_"),
  //     sortable: true,
  //     center: false,
  //   },

  //   {
  //     name: "Experience",

  //     cell: (row) => {
  //       const experienceOutput = formatExperienceOutput(
  //         row.work_experience_min,
  //         row.work_experience_max
  //       );
  //       return experienceOutput !== "N/A" ? experienceOutput : "-";
  //     },

  //     sortable: false,
  //     center: true,
  //   },
  //   {
  //     name: "Location",
  //     short_column: "job_location",
  //     cell: (row) => (row.job_location ? capitalize(row.job_location) : "_"),
  //     sortable: true,
  //     center: false,
  //   },
  //   {
  //     name: "Created At",
  //     short_column: "created_at",
  //     cell: (row) => (row.created_at ? formatDate(row.created_at) : "_"),
  //     sortable: true,
  //     center: false,
  //   },

  //   {
  //     name: "Actions",
  //     selector: (row) => (
  //       <div>
  //         <span>
  //           <Link
  //             to={`${process.env.PUBLIC_URL
  //               }/jobseeker/job_details/${generateSlug(
  //                 row.job_name,
  //                 row.job_location,
  //                 formatExperienceOutput(
  //                   row.work_experience_min,
  //                   row.work_experience_max
  //                 ).replace("-", "-to-"),
  //                 row.job_id
  //               )}`}
  //             title="View Job"
  //           >
  //             <Eye
  //               size={18}
  //               className="eye-icon"
  //               style={{ marginRight: "7px" }}
  //             />
  //           </Link>
  //           <span title="Delete Job">
  //             <Trash2
  //               size={18}
  //               onClick={() => handleDelete(row.saved_job_id)} // Pass jobId to handleDelete
  //               className="delete-icon"
  //               style={{ cursor: "pointer" }}
  //             />
  //           </span>
  //         </span>
  //       </div>
  //     ),
  //     sortable: false,
  //     center: true,
  //   },
  // ];


  const tableColumns = [
    {
      name: "#",
      short_column: "job_id",
      cell: (row, index) => (currentPage - 1) * perPage + index + 1,
      width: "60px", // Use a fixed, small width for the index column for consistency
      sortable: true,
    },
    {
      name: "Job Title",
      short_column: "job_name",
      sortable: true,
      grow: 3, // Allow this primary column the most space to grow
      minWidth: '180px', // Ensure the title doesn't get overly squished
      cell: (row) =>
        row.job_name ? (
          // Wrapper div is crucial for reliable text-overflow ellipsis
          <div
            style={{
              width: '100%',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
            title={capitalize(row.job_name)} // The tooltip shows the full title on hover
          >
            <Link
              to={`${process.env.PUBLIC_URL}/jobseeker/job_details/${generateSlug(
                row.job_name,
                row.job_location,
                formatExperienceOutput(
                  row.work_experience_min,
                  row.work_experience_max
                ).replace("-", "-to-"),
                row.job_id
              )}`}
            >
              {capitalize(row.job_name)}
            </Link>
          </div>
        ) : (
          "-"
        ),
    },
    {
      name: "Company Name",
      short_column: "company_name",
      sortable: true,
      grow: 2, // Give company name significant space
      minWidth: '150px',
      cell: (row) =>
        row.company_name ? (
          <div
            style={{
              width: '100%',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
            title={capitalize(row.company_name)}
          >
            {capitalize(row.company_name)}
          </div>
        ) : (
          "-"
        ),
    },
    {
      name: "Experience",
      sortable: false,
      center: true,
      grow: 1.5,
      minWidth: '120px',
      cell: (row) => {
        const experienceOutput = formatExperienceOutput(
          row.work_experience_min,
          row.work_experience_max
        );
        return experienceOutput !== "N/A" ? experienceOutput : "-";
      },
    },
    {
      name: "Location",
      short_column: "job_location",
      sortable: true,
      grow: 2,
      minWidth: '140px',
      cell: (row) => (row.job_location ? capitalize(row.job_location) : "-"),
    },
    {
      name: "Created At",
      short_column: "created_at",
      sortable: true,
      grow: 1.5,
      minWidth: '120px',
      cell: (row) => (row.created_at ? formatDate(row.created_at) : "-"),
    },
    {
      name: "Actions",
      sortable: false,
      center: true,
      width: '100px', // A fixed width is best for multi-icon action columns
      cell: (row) => (
        <div className="d-flex justify-content-center align-items-center gap-3">
          <Link
            to={`${process.env.PUBLIC_URL
              }/jobseeker/job_details/${generateSlug(
                row.job_name,
                row.job_location,
                formatExperienceOutput(
                  row.work_experience_min,
                  row.work_experience_max
                ).replace("-", "-to-"),
                row.job_id
              )}`}
            title="View Job"
          >
            <Eye
              size={18}
              className="eye-icon"
            />
          </Link>
          <span title="Delete Job">
            <Trash2
              size={18}
              onClick={() => handleDelete(row.saved_job_id)} // Pass jobId to handleDelete
              className="delete-icon"
              style={{ cursor: "pointer" }}
            />
          </span>
        </div>
      ),
    },
  ];



  const fetchJobs = () => {
    const data = {
      type: formData.dateRange.type,

      startDate: formData.dateRange.startDate
        ? formData.dateRange.startDate.toISOString()
        : null, // Convert Date objects to strings
      endDate: formData.dateRange.endDate
        ? formData.dateRange.endDate.toISOString()
        : null,
      keyword: searchQuery,
    };
    dispatch(fetchFavoriteJobsRequest(currentPage,
      perPage, data, sortColumn, sortDirection));
  }
  const handleSort = async (column, direction) => {
    setSortColumn(column.short_column);
    setSortDirection(direction);
    // fetchJobs(); // Fetch jobs with new sorting

  };

  const handleDelete = (jobId) => {
    showSweetAlert("confirm", {
      message: "You want to delete the job",
      fun: deleteSavedJob,
      id: jobId,
    });
  };

  const deleteSavedJob = (id) => {
    // Dispatch the delete action here
    dispatch(deleteFavoriteJobRequest({ saved_job_id: id }));
  };

  const favoriteJobReducerData = useSelector(
    (state) => state.favoriteJobReducer
  );
  const favoriteJobData = favoriteJobReducerData.data.data || [];

  useEffect(() => {
    if (favoriteJobReducerData.status && favoriteJobReducerData.message != "") {
      showToast("success", favoriteJobReducerData.message);
      const data = {
        type: formData.dateRange.type,

        startDate: formData.dateRange.startDate
          ? formData.dateRange.startDate.toISOString()
          : null, // Convert Date objects to strings
        endDate: formData.dateRange.endDate
          ? formData.dateRange.endDate.toISOString()
          : null,
        keyword: searchQuery,
      };
      dispatch(fetchFavoriteJobsRequest(currentPage, perPage, data));
      dispatch(resetFavoriteMessage());
    } else if (
      favoriteJobReducerData.status == false &&
      favoriteJobReducerData.message != ""
    ) {
      showToast("error", favoriteJobReducerData.message);

      dispatch(resetFavoriteMessage());
    }
  }, [favoriteJobReducerData, currentPage, perPage]);

  return (
    <Fragment>
      <Row>
        <Col sm="12">
          <Card>
            <CardHeader className="py-3">
              <div className="d-flex flex-wrap justify-content-between align-items-end">
                {/* Search Bar */}
                <Form
                  className="theme-form me-2 flex-grow-1"
                  onSubmit={handleSubmit}
                >
                  <div
                    className="input-group flex-nowrap"
                    style={{ height: 35, maxWidth: "350px" }}
                  >
                    <Input
                      className="form-control"
                      value={searchQuery}
                      onChange={handleSearchChange}
                      type="search"
                      placeholder="Search.."
                    />
                    <Button
                      color="primary"
                      type="submit"
                      className="btn-primary input-group-text pe-3 ps-3"
                    >
                      Search
                    </Button>
                  </div>
                </Form>

                {/* Date Picker Button */}
                <div className="d-flex align-items-center ms-auto mt-3 mt-md-0">
                  <Button
                    color="primary"
                    id="shownCalendar"
                    onClick={() => setDatePickerOpen(!datePickerOpen)}
                    className="btn btn-primary d-flex align-items-center ps-3 pe-3"
                  >
                    <FaCalendarAlt />
                    <span className="ms-2">
                      {formData &&
                        (formData.dateRange.type === "CUSTOM"
                          ? `${formatDate(
                            formData.dateRange.startDate,
                            "dd-MM-yyyy"
                          )} - ${formatDate(
                            formData.dateRange.endDate,
                            "dd-MM-yyyy"
                          )}`
                          : unslugAndCapitalize(formData.dateRange.type))}
                    </span>
                  </Button>
                  {datePickerOpen && (
                    <div
                      style={{
                        position: "absolute",
                        top: "50px", // Adjust as needed based on your layout
                        right: "0",
                        zIndex: 1000,
                      }}
                    >
                      <DateRangePicker
                        editableDateInputs
                        onChange={handleDateRangeChange}
                        ranges={[formData.dateRange]}
                        locale={locale}
                        direction="horizontal"
                        open={datePickerOpen}
                        onToggle={(open) => setDatePickerOpen(open)}
                        staticRanges={customStaticRanges}
                      />
                    </div>
                  )}
                </div>
              </div>
            </CardHeader>

            <CardBody className="px-0 py-3">
              {/* <StyledDataTable> */}
              <div className="table-container">
                <DataTable
                  // responsive
                  customStyles={customStyles}
                  data={favoriteJobData}
                  columns={tableColumns}
                  keyField="id"
                  striped={true}
                  center={true}
                  pagination
                  paginationServer
                  paginationTotalRows={favoriteJobReducerData.data.total}
                  paginationPerPage={perPage}
                  onChangePage={handlePageChange}
                  onChangeRowsPerPage={handlePerRowsChange}
                  clearSelectedRows={toggleDelet}
                  headerComponent={CustomHeader}
                  progressPending={favoriteJobReducerData.isLoading}
                  progressComponent={<Spinner />}
                  noDataComponent={
                    <NoDataFound message={"No saved jobs found"} />
                  }
                  onSort={(column, direction) => handleSort(column, direction)}
                />{" "}
              </div>
              {/* </StyledDataTable> */}
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Fragment>
  );
};

export default SavedJobs;
